import { render, staticRenderFns } from "./searchRecommend.vue?vue&type=template&id=26934c36&scoped=true&"
import script from "./searchRecommend.vue?vue&type=script&lang=js&"
export * from "./searchRecommend.vue?vue&type=script&lang=js&"
import style0 from "./searchRecommend.vue?vue&type=style&index=0&id=26934c36&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26934c36",
  null
  
)

export default component.exports